import React from 'react'
import { CCard, CCardBody, CSmartTable } from '@coreui/react-pro'
import { resolvePlayerImageUrl } from 'src/utils/imageUrl'

const Sparkline = ({ points }) => {
  if (!points || points.length < 2) return <span className="text-medium-emphasis">—</span>
  const min = Math.min(...points)
  const max = Math.max(...points)
  const range = max - min || 1
  const width = 64
  const height = 24
  const step = width / (points.length - 1)
  const coords = points
    .map((p, i) => `${(i * step).toFixed(1)},${(height - ((p - min) / range) * height).toFixed(1)}`)
    .join(' ')
  const isUp = points[points.length - 1] >= points[0]
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <polyline
        points={coords}
        fill="none"
        stroke={isUp ? '#2eb85c' : '#e55353'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const PlayerValueTable = (props) => {
  return (
    <CCard>
      <CCardBody>
        <CSmartTable
          columns={props.columns}
          columnSorter={{
            external: true,
          }}
          scopedColumns={{
            image: (item) => {
              const imgSrc = resolvePlayerImageUrl(item)
              return (
                <td>
                  {imgSrc ? (
                    <img src={imgSrc} alt="" width="40" height="40" className="rounded-circle" />
                  ) : (
                    '—'
                  )}
                </td>
              )
            },
            team_name: (item) => <td>{item?.team_name || '—'}</td>,
            position_name: (item) => <td>{item?.position_name || '—'}</td>,
            initial_value: (item) => <td>${Number(item?.initial_value ?? 0).toFixed(2)}m</td>,
            svalue: (item) => <td>${Number(item?.svalue ?? 0).toFixed(2)}m</td>,
            value_change: (item) => {
              const change = Number(item?.value_change ?? 0)
              return (
                <td className={change > 0 ? 'text-success' : change < 0 ? 'text-danger' : ''}>
                  {change > 0 ? '+' : ''}
                  {change.toFixed(2)}m
                </td>
              )
            },
            value_change_in_percent: (item) => {
              const change = Number(item?.value_change_in_percent ?? 0)
              return (
                <td className={change > 0 ? 'text-success' : change < 0 ? 'text-danger' : ''}>
                  {change > 0 ? '+' : ''}
                  {change.toFixed(2)}%
                </td>
              )
            },
            trend: (item) => (
              <td>
                <Sparkline points={item?.value_trend} />
              </td>
            ),
          }}
          items={props.users?.data}
          itemsPerPage={props.itemsPerPage}
          itemsPerPageSelect
          loading={props.loading}
          pagination={{
            external: true,
          }}
          paginationProps={{
            activePage: props.activePage,
            pages: Math.ceil(props.users?.total / props.itemsPerPage) || 1,
          }}
          tableProps={{
            hover: true,
            responsive: true,
            className: 'align-middle mb-0',
          }}
          onActivePageChange={(activePage) => props.setActivePage(activePage)}
          onItemsPerPageChange={(itemsPerPage) => {
            props.setActivePage(1)
            props.setItemsPerPage(itemsPerPage)
          }}
          onSorterChange={(sorter) => props.setColumnSorter(sorter)}
        />
      </CCardBody>
    </CCard>
  )
}

export default PlayerValueTable
